import styled from "styled-components";

export const AuthPageContainer = styled.div`
  width: 100vw;
  height: 100vh;
  max-width: 100%;
  max-height: 100%;
`;
